<p>folder-pop-up works!</p>
